import { createSelector } from 'reselect'

import { EMPTY_ARRAY } from 'utils/emptyConstants'

import {
  selectActualCompanyId,
  selectPartner,
  selectSelfCompanyId,
  selectSortedCompanies,
} from 'containers/App/selectors'

const selectAlertsV2 = (state) => state.settings?.alertsV2

export const selectIsMspPartner = (state) => {
  if (!selectPartner(state)) return false
  const actingCompanyId = selectActualCompanyId(state)
  const selfCompanyId = selectSelfCompanyId(state)
  if (actingCompanyId == null || selfCompanyId == null) return true
  return String(actingCompanyId) === String(selfCompanyId)
}

export const selectChildTenants = createSelector(
  [selectIsMspPartner, selectSortedCompanies],
  (isMspPartner, companies) =>
    isMspPartner ? companies.map(({ id, name }) => ({ id, name })) : EMPTY_ARRAY
)

export const selectActiveTab = (state) => selectAlertsV2(state)?.activeTab
export const selectEndpoints = (state) => selectAlertsV2(state)?.endpoints || EMPTY_ARRAY
export const selectEndpointsLoader = (state) => selectAlertsV2(state)?.endpointsLoader ?? false
export const selectEndpointsError = (state) => selectAlertsV2(state)?.endpointsError
export const selectEndpointDetailLoader = (state) =>
  selectAlertsV2(state)?.endpointDetailLoader ?? false
export const selectEndpointSaving = (state) => selectAlertsV2(state)?.endpointSaving ?? false
export const selectSetupPrompt = (state) =>
  selectAlertsV2(state)?.setupPrompt || { open: false, endpointId: null, name: '' }
export const selectSefToast = (state) => selectAlertsV2(state)?.sefToast
export const selectEventRulesLoader = (state) => selectAlertsV2(state)?.eventRulesLoader ?? false
export const selectEventRulesError = (state) => selectAlertsV2(state)?.eventRulesError
export const selectEventRules = (state) => selectAlertsV2(state)?.eventRules || EMPTY_ARRAY
export const selectCanEnableAllCompanies = (state) =>
  selectAlertsV2(state)?.canEnableAllCompanies ?? null
export const selectDrawer = (state) =>
  selectAlertsV2(state)?.drawer || {
    open: false,
    type: null,
    mode: null,
    id: null,
    preselectEndpointIds: [],
  }
export const selectDeleteConfirm = (state) =>
  selectAlertsV2(state)?.deleteConfirm || { open: false, entityType: null, id: null }

export const selectDrawerEndpoint = (state) => {
  const drawer = selectDrawer(state)
  if (!drawer.open || drawer.type !== 'endpoint' || drawer.id == null) return null
  const detail = selectAlertsV2(state)?.endpointDetail
  if (detail?.id === drawer.id) return detail
  return selectEndpoints(state).find((ep) => ep.id === drawer.id) || null
}

const selectRuleDetail = (state) => selectAlertsV2(state)?.ruleDetail

export const selectDrawerEventRule = createSelector(
  [selectDrawer, selectEventRules, selectRuleDetail],
  (drawer, eventRules, ruleDetail) => {
    if (!drawer.open || drawer.type !== 'eventRule' || drawer.id == null) return null
    const rule = eventRules.find((item) => item.id === drawer.id)
    if (!rule) return null
    return ruleDetail?.id === rule.id ? { ...rule, ...ruleDetail } : rule
  }
)
